module.exports = __webpack_public_path__ + "static/pwb3-fa124ce03876810f182e99b357c06f1c.jpg";